// extracted by mini-css-extract-plugin
export default {"map":"UJCqYdNG4f"};
    if(module.hot) {
      // 1625219500745
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  